// extracted by mini-css-extract-plugin
export var container = "_6s-0";
export var error = "_6s-9";
export var label = "_6s-5";
export var light = "_6s-6";
export var md = "_6s-3";
export var sm = "_6s-2";
export var thin = "_6s-8";
export var thinBold = "_6s-7";
export var vertical = "_6s-4";
export var xs = "_6s-1";